// Story #41530: Import shared datetime utilities
import { getEntryTimeDates } from '../utils/dateTimeUtils';
angular.module('leanlaw').directive('entryEdit', [function () {
  return {
    restrict: 'E',
    require: 'ngModel',
    template: require('./views/entryEdit.html'),
    scope: {
      ngModel: '=',
      originalEntry: '=',
      saveEntry: '=',
      closeEntry: '&',
      deleteEntry: '&?',
      // Allows pending state for form and spinner button
      isSaving: '=?',
      clients: '=',
      matters: '=',
      isEntryValid: '=?',
      disableAdd: '=?',
      limitClient: '=?',
      limitMatter: '=?',
      clientsHint: '=',
      hideClientMatter: '='
    },
    controller: ['$scope', 'codeService', 'userService', 'entriesManager', 'entryEditService', 'snippetService', 'alerts', 'leanLawApi', 'lists', 'matterManager', 'clientManager', ($scope, codeService, userService, entriesManager, entryEditService, snippetService, alerts, leanLawApi, lists, matterManager, clientManager) => {
      $scope.vm = {
        me: undefined,
        codes: [],
        accounts: [],
        tasks: [],
        advancedState: 'Standard',
        selectedTask: undefined,
        rateList: [],
        switchOption: '',
        isDescriptionFocused: false,
        okToClearDescription: false,
        hideClientMatter: $scope.hideClientMatter || false,
        newEntryFromOld: $scope.ngModel.newEntryFromOld || false,
        lockCalculatingHoursFromDescription: false,
        showDecimalError: false,
        entryBillingTypes: [],
        loadingEntryBillingTypes: false,
        disableSave: false,
        fixedFeeList: [],
        billingType: {},
        client: null,
        matter: null,
        account: {},
        activated: false,
        preventCMReset: true
      };
      $scope.cmQuery = {
        originating: false,
        involved: false,
        reviewer: false,
        primary: false,
        scopeAccount: $scope.ngModel.account?.id || '',
        status: '',
        archived: false
      };

      // functions
      activate();
      $scope.$watch('ngModel', async (newValue, oldValue) => {
        // This watch is for when new entries are selected, we want to
        // reset the step value and adjust rate dropdown
        if (!$scope.ngModel) return;
        // assign to vm :)
        entryEditService.updateStep($scope.ngModel.hours);
        $scope.ngModel.date = new Date($scope.ngModel.date);
        $scope.vm.originalDescription = $scope.ngModel.description;
        $scope.vm.originalHours = $scope.ngModel.hours;
        $scope.vm.lockCalculatingHoursFromDescription = false;
        $scope.vm.entryBillingTypes = angular.copy(lists.entryBillingTypes);
        $scope.vm.billingType = $scope.vm.entryBillingTypes.find(t => t.id === $scope.ngModel.billingType);

        // Story #41530: Use shared utility for localDateTime support
        var useDateHandling = $scope.vm.me && $scope.vm.me.features && $scope.vm.me.features.dateHandling;
        var timeDates = getEntryTimeDates($scope.ngModel, useDateHandling);
        if (timeDates.startTime) {
          $scope.ngModel.startTime = timeDates.startTime;
          // Also update originalEntry to prevent false "entry changed" detection
          if ($scope.originalEntry) {
            $scope.originalEntry.startTime = timeDates.startTime;
          }
        }
        if (timeDates.endTime) {
          $scope.ngModel.endTime = timeDates.endTime;
          // Also update originalEntry to prevent false "entry changed" detection
          if ($scope.originalEntry) {
            $scope.originalEntry.endTime = timeDates.endTime;
          }
        }
        if (newValue.id) {
          // existing entry => set client/matter from newValue
          $scope.vm.client = newValue.matter ? {
            id: newValue.matter.client?.id,
            label: newValue.matter.client?.label
          } : null;
          $scope.vm.matter = newValue.matter ? {
            id: newValue.matter?.id,
            label: newValue.matter?.label
          } : null;
        } else {
          $scope.vm.client = $scope.ngModel.client ? {
            id: $scope.ngModel.client?.id,
            label: $scope.ngModel.client?.label
          } : null;
          $scope.vm.matter = $scope.ngModel.matter ? {
            id: $scope.ngModel.matter?.id,
            label: $scope.ngModel.matter?.label
          } : null;
        }
        const {
          id
        } = $scope.ngModel.account || {};
        const user = $scope.vm.accounts?.find(u => u?.id === id);

        // Filter only valid accounts, skipping the 'disabled' and 'accountant' role accounts.
        $scope.vm.accounts = $scope.vm.accounts?.filter(u => u?.role !== 'accountant');
        if (!user) {
          $scope.vm.accounts.push($scope.ngModel.account);
        }

        // If the current user is 'disabled' or has the role of 'accountant' and is not in the list, add them back.
        if (user && user.role === 'accountant' && $scope.ngModel.id) {
          if (!$scope.vm.accounts?.find(a => a?.id === id)) {
            $scope.vm.accounts.push(user);
          }
        }
        if ($scope.vm.billingType?.id === 'fixedFee') {
          await getCharge();
          const chargeId = $scope.ngModel?.charge?.id;
          if (chargeId) {
            $scope.vm.fixedFee = $scope.vm.fixedFeeList.find(charge => charge?.id === chargeId);
          } else {
            $scope.vm.fixedFee = {};
          }
        }
        if ($scope.ngModel.isFromCreateNewEntry) {
          adjustRateToSelection(true);
        } else {
          adjustRateToSelection(false);
        }
        const {
          autoAssign
        } = $scope.vm?.me?.permissions?.matters || {};
        $scope.cmQuery.involved = !autoAssign;
        $scope.cmQuery.scopeAccount = autoAssign ? '' : $scope.ngModel.account ? $scope.ngModel.account.id : '';
        // updating the cmquery's involved flag based on auto assign matter permission(Users should be able to find or select clients/matters they're not included on)

        $scope.vm.activated = true;
      });
      async function getCharge() {
        await entryEditService.getChargeList($scope.ngModel.matter, $scope.vm, $scope.ngModel);
      }

      // Returns whether the selected/new entry has been modified by the user
      $scope.hasEntryChanged = function hasEntryChanged() {
        let ignoreStartStop = false;
        if ($scope.vm.switchOption !== 'Start/End') {
          ignoreStartStop = true;
        }
        return entriesManager.compareEntries($scope.originalEntry, $scope.ngModel, ignoreStartStop);
      };
      $scope.accountChanged = function () {
        if ($scope.ngModel.account && $scope.ngModel.account.id) {
          $scope.cmQuery.scopeAccount = $scope.ngModel.account.id;
          const {
            autoAssign
          } = $scope.vm?.me?.permissions?.matters || {};
          if (autoAssign || $scope.ngModel.account !== undefined && $scope.ngModel.account.id !== $scope.vm.me?.id) {
            $scope.cmQuery.involved = !autoAssign;
            $scope.cmQuery.scopeAccount = autoAssign ? '' : $scope.cmQuery.scopeAccount;
          }
        } else {
          $scope.cmQuery.scopeAccount = '';
        }
        adjustRateToSelection(true);
      };
      $scope.checkPrecision = function () {
        let hours = $scope.ngModel.hours;
        $scope.vm.showDecimalError = parseFloat(hours) !== parseFloat(hours.toFixed(2));
      };
      $scope.changeHours = function () {
        if ($scope.vm.switchOption == 'Start/End') {
          entryEditService.updateEndTime($scope.ngModel);
        }
        $scope.checkPrecision();
        entryEditService.updateStepFromEntry($scope.ngModel);
        $scope.vm.lockCalculatingHoursFromDescription = true;
      };
      $scope.changeStartTime = function () {
        if (!$scope.ngModel.startTime) return;
        entryEditService.updateEndTime($scope.ngModel);
      };
      $scope.changeEndTime = function () {
        entryEditService.updateHours($scope.ngModel);
      };

      // Sets the description, clears the task dropdown, and focuses the desc.
      $scope.taskSelected = function (task) {
        entryEditService.updateDescriptionFromTask($scope.ngModel, task);
        // Clear the selected task in the dropdown
        $scope.vm.selectedTask = null;
        $scope.vm.isDescriptionFocused = true;
      };

      // Sets the description, clears the task dropdown, and focuses the desc.
      $scope.setDescription = function setDescription(newDescription) {
        $scope.ngModel.description = newDescription;
        // Clear the selected task in the dropdown
        $scope.vm.selectedTask = null;
        $scope.vm.isDescriptionFocused = true;
      };
      $scope.setLedesDescription = function (code, activity, task) {
        if (!code) return;
        const codesSettings = $scope.vm.me.company.settings.codes || {};
        let description = '';
        if (codesSettings.populateDescriptionsPlus) {
          // For populateDescriptionsPlus: always check both codes and combine them
          let activityDesc = $scope.ngModel.codes.activity ? $scope.ngModel.codes.activity.label : '';
          let taskDesc = $scope.ngModel.codes.task ? $scope.ngModel.codes.task.label : '';
          if (activityDesc && taskDesc) {
            description = `${activityDesc}, ${taskDesc}`;
          } else if (activityDesc) {
            description = activityDesc;
          } else if (taskDesc) {
            description = taskDesc;
          }
        } else {
          // For populateDescriptions only: use the most recently selected code 
          if (activity && $scope.ngModel.codes?.activity?.label) {
            description = $scope.ngModel.codes.activity.label;
          }
          if (task && $scope.ngModel.codes?.task?.label) {
            description = $scope.ngModel.codes.task.label;
          }
        }
        if (codesSettings.populateDescriptions && ($scope.vm.okToClearDescription || !$scope.ngModel.description)) {
          $scope.ngModel.description = description;
          $scope.vm.okToClearDescription = true;
        }
      };
      $scope.changeBillingType = async function (autoAssign) {
        if (!$scope.vm.billingType) return;
        $scope.vm.fixedFeeList = [];
        const {
          id
        } = $scope.vm.billingType;
        let oldType = $scope.ngModel.billingType;
        if (oldType === 'nonBillable') {
          adjustRateToSelection(true, true);
        }
        $scope.ngModel.billingType = id;
        if (id === 'fixedFee') {
          await entryEditService.getChargeList($scope.ngModel.matter, $scope.vm, $scope.ngModel);
          if ($scope.vm.fixedFeeList.length === 1 && autoAssign) {
            const fixedFeeItem = $scope.vm.fixedFeeList[0];
            // setting vm.fixedFee = {} to avoid issue with vm.fixedFee.id = undefined
            $scope.vm.fixedFee = {};
            $scope.vm.fixedFeeList[0].display = fixedFeeItem.displayName || fixedFeeItem.label || fixedFeeItem.description;
            $scope.vm.fixedFee.id = fixedFeeItem.id;
          }
        } else {
          $scope.vm.fixedFee = {};
          $scope.ngModel.charge = {};
          $scope.ngModel.chargeId = undefined;
          if (id === 'billable') {
            entryEditService.adjustRateToCompletionBasedSelection($scope.ngModel, $scope.ngModel.account, $scope.vm);
          }
        }
      };
      $scope.changeCharge = function (force) {
        // We need to ensure chargeType is properly accessed
        const selectedCharge = $scope.vm?.fixedFee;

        // If no charge is selected, clear the model
        if (!selectedCharge || !selectedCharge.id) {
          $scope.ngModel.charge = {};
          $scope.ngModel.chargeId = undefined;
          return;
        }

        // Update the model with the selected charge
        $scope.ngModel.charge = angular.copy(selectedCharge);
        $scope.ngModel.chargeId = selectedCharge.id;
      };

      // Initialize Chosen dropdown after options change
      $scope.initializeChosenDropdown = function () {
        // Use $timeout to ensure this runs after DOM update
        setTimeout(function () {
          // If jQuery and Chosen plugin are available
          if (window.$ && typeof window.$.fn.chosen === 'function') {
            const element = $('.fixed-fee-select');
            if (element.length > 0) {
              element.trigger('chosen:updated');
            }
          }
        }, 0);
      };

      // Handle fixed fee selection separately
      $scope.handleFixedFeeSelection = function (charge) {
        if (!charge) return;

        // Ensure the charge object has all needed properties
        if (typeof charge === 'string') {
          // If we just got an ID, find the full charge object
          const selectedCharge = $scope.vm.fixedFeeList.find(item => item.id === charge);
          if (selectedCharge) {
            $scope.vm.fixedFee = selectedCharge;
          } else {
            console.warn('Could not find charge with ID:', charge);
            return;
          }
        } else {
          $scope.vm.fixedFee = charge;
        }

        // Update the model
        $scope.changeCharge(true);

        // Ensure dropdown is updated properly
        $scope.initializeChosenDropdown();
      };

      // Replace the existing watch with a specific ID comparison
      $scope.$watch('vm.fixedFee.id', (newVal, oldVal) => {
        if (newVal !== oldVal) {
          $scope.changeCharge(true);
          $scope.initializeChosenDropdown();
        }
      });

      // Watch the fixedFeeList and reinitialize Chosen when it changes
      $scope.$watchCollection('vm.fixedFeeList', function () {
        $scope.initializeChosenDropdown();
      });
      $scope.matterChanged = function () {
        $scope.vm.fixedFee = {};
        $scope.ngModel.charge = {};
        $scope.ngModel.chargeId = undefined;
        if ($scope.ngModel.matter && !$scope.ngModel.id) {
          if ($scope.ngModel.client?.codes?.ledes) {
            $scope.ngModel.codes = $scope.ngModel.codes || {};
            if ($scope.vm.codes.task.length == 1) {
              $scope.ngModel.codes.task = $scope.vm.codes.task[0];
            }
            if ($scope.vm.codes.activity.length == 1) {
              $scope.ngModel.codes.activity = $scope.vm.codes.activity[0];
            }
          }
        }
        adjustRateToSelection(true);
      };

      // WATCH: If the user changes vm.client in the UI, update ngModel.client
      $scope.$watch('vm.client', (newVal, oldVal) => {
        // Only update if it's actually a different client
        if (newVal?.id && newVal.id !== oldVal?.id) {
          $scope.ngModel.client = newVal;
        } else if (!newVal?.id) {
          // user cleared the client
          $scope.ngModel.client = null;
        }
      });
      $scope.$watch('vm.matter', (newVal, oldVal) => {
        if (newVal?.id && newVal?.id !== oldVal?.id && newVal?.id !== $scope.ngModel.matter?.id) {
          // Disable Save the moment the matter changes so a quick
          // "switch matter then Save" can't persist the entry before the
          // new matter (and its rate) has been fetched. It stays disabled
          // through the rate fetch and is re-enabled by adjustRateToSelection
          // (invoked via matterChanged) once the rate has been applied.
          $scope.vm.disableSave = true;
          $scope.vm.loadingEntryBillingTypes = true;
          matterManager.get($scope.vm.matter.id).then(matter => {
            $scope.ngModel.matter = matter;
            $scope.vm.entryBillingTypes = lists.entryBillingTypes;
            newEntryBillingType(matter);
            if ($scope.vm.matter) {
              clientManager.get($scope.vm.matter.clientId).then(client => {
                $scope.vm.matter.client = client;
                $scope.vm.client = client;
                $scope.ngModel.client = client;
              });
            }
            $scope.matterChanged();
            $scope.vm.loadingEntryBillingTypes = false;
          });
        }
      });
      async function adjustRateToSelection(refresh, preserveBillingType) {
        // Keep Save disabled until the matter's rate has actually been
        // fetched and applied to the entry, so it can't be saved with the
        // previously selected matter's rate. $applyAsync is used because
        // execution resumes outside Angular's digest after the await.
        $scope.$applyAsync(() => {
          $scope.vm.disableSave = true;
        });
        try {
          await entryEditService.adjustRateToSelection(refresh, $scope.ngModel, $scope.ngModel.account, $scope.vm, preserveBillingType);
        } finally {
          $scope.$applyAsync(() => {
            $scope.vm.disableSave = false;
          });
        }
      }
      function newEntryBillingType(matter) {
        if (!matter) return;
        const {
          type
        } = matter.billing;
        $scope.vm.billingType = type === 'hours' ? $scope.vm.entryBillingTypes.find(x => x.id === 'billable') : type === 'fixed' ? $scope.vm.entryBillingTypes.find(x => x.id === 'fixedFee') : $scope.vm.entryBillingTypes.find(x => x.id === 'nonBillable');
      }
      $scope.rateChanged = function () {
        const {
          selectedRate
        } = $scope.vm;
        if (selectedRate) {
          // Rate selected, mark as edited
          $scope.ngModel.rate = {
            ...selectedRate,
            edited: true
          };
        } else {
          // Rate unselected, revert back to default
          adjustRateToSelection(true);
        }
      };
      $scope.manualRateChanged = function () {
        $scope.vm.selectedRate = null;
        $scope.ngModel.rate.label = '';
        $scope.ngModel.rate.edited = true;
      };
      $scope.descriptionChanged = function () {
        $scope.vm.okToClearDescription = false;
        $scope.ngModel.hours = entryEditService.descriptionHours($scope.ngModel, $scope.vm) || $scope.ngModel.hours;
      };
      $scope.save = function save() {
        // Guard against a submit (e.g. the Enter key) landing while the
        // matter's rate is still being fetched — a disabled button alone
        // won't stop form submission.
        if ($scope.vm.disableSave) {
          return;
        }
        $scope.ngModel.billingType = $scope.vm.billingType.id;
        if ($scope.entryForm.description.$invalid) {
          alerts.error('A description is required.');
        }
        if ($scope.entryForm?.activityCode?.$invalid) {
          alerts.error('Activity code is required.');
        }
        if ($scope.entryForm?.taskCode?.$invalid) {
          alerts.error('Task code is required.');
        }
        if (!$scope.entryForm.hours.$viewValue) {
          alerts.error('Hours must be greater than zero.');
        }
        if ($scope.ngModel.rate?.amount < 0) {
          alerts.error('Amount cannot be negative');
          return;
        }
        if ($scope.entryForm.hours.$invalid && $scope.entryForm.hours.$viewValue) {
          let floatValue = parseFloat($scope.entryForm.hours.$viewValue);
          if (parseFloat(floatValue.toFixed(2)) !== floatValue) {
            alerts.error('New time entries cannot have more than 2 decimal places');
          } else if ($scope.enforcedRounding) {
            alerts.error(`Your firm has Enforced Rounding enabled. Your Hours must be an increment of ${$scope.vm.me.company.settings.timeEntryIncrement}.`);
          }
        }
        if ($scope.entryForm.$invalid) {
          return;
        }
        if (!$scope.ngModel.matter.client?.codes?.ledes && $scope.vm.me.company.settings?.codes?.ledes) {
          $scope.ngModel.codes = {};
        }
        $scope.ngModel.isFromCreateNewEntry = false;
        $scope.saveEntry(true);
        snippetService.reset();
      };
      $scope.$on('clearClientMatter', () => {
        $scope.clear();
      });
      $scope.clear = function clear() {
        $scope.ngModel.matter = null;
        $scope.ngModel.client = null;
        $scope.vm.client = null;
        $scope.vm.matter = null;
      };
      async function activate() {
        $scope.getStep = entryEditService.getStep;
        $scope.getMinuteStep = entryEditService.getMinuteStep;
        $scope.getTaskLabel = snippetService.getTaskLabel;
        $scope.enforcedRounding = false;
        entryEditService.resetStep();
        codeService.activityCodes().then(activity => {
          $scope.vm.codes.activity = activity;
        });
        codeService.taskCodes().then(task => {
          $scope.vm.codes.task = task;
        });
        userService.list().then(users => {
          $scope.vm.accounts = users;
        });
        leanLawApi.listTasks().then(list => {
          $scope.vm.tasks = list.tasks;
          snippetService.addShortCodeHandler('timeentry-description', $scope.vm.tasks);
          snippetService.addShortCodeHandler('notes-description', $scope.vm.tasks);
        });
        $scope.vm.entryBillingTypes = lists.entryBillingTypes;
        $scope.ngModel.date = new Date();
        $scope.ngModel.startTime = new Date();
        entryEditService.updateEndTime($scope.ngModel);
        const me = await userService.me();
        $scope.vm.me = me;
        $scope.enforcedRounding = $scope.vm.me.company.settings.enforceRounding;
      }

      // Let parent know if the entry form is valid
      $scope.$watch('entryForm.$valid', newValue => {
        $scope.isEntryValid = newValue;
      });
    }]
  };
}]);